import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedCriticalIllnessPlans {
    
    public readonly key = 'UnassignedCriticalIllnessPlans';
  }

export type CriticalIllnessPlans = Async<string[]> | UnassignedCriticalIllnessPlans;

type MatchCriticalIllnessPlanOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (planTypes: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (planTypes: []) => TReturn;
  };

export const isLoading = (planTypes: CriticalIllnessPlans): planTypes is Loading<string[]> =>
    planTypes.key === 'Loading';

export const isLoaded = (planTypes: CriticalIllnessPlans): planTypes is Loaded<string[]> => planTypes.key === 'Loaded';

export const matchCriticalIllnessProduct = <TReturn>(options: MatchCriticalIllnessPlanOptions<TReturn>) => (
    products: CriticalIllnessPlans
  ) => {
  
    switch (products.key) {
      case 'UnassignedCriticalIllnessPlans':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  